import { bl_fi_fixed_asset_category_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AssetRegisterCategoryContainerModel extends BaseContainerModel {
  bl_fi_fixed_asset_category: bl_fi_fixed_asset_category_RowClass = new bl_fi_fixed_asset_category_RowClass();
}

export class AssetRegisterCategoryQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  keyword: string;
  txn_type: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  param_code: string;
  value_string: string;
}
